import { makeStyles } from "@material-ui/core";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles(({ palette: { primary, custom } }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    height: 32,
    margin: 4,
    transition: "width 100ms",
  },
  root_full: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "auto",
    height: "auto",
    margin: 0,
    padding: "0 12px",
    background: custom.high,
    zIndex: 1,
  },
  rootButton: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    height: 32,
    margin: "0 4px",
    background: "none",
    border: 0,
    outline: 0,
    cursor: "pointer",
    borderRadius: 4,
    "&::before": {
      content: "''",
      position: "absolute",
      top: -4,
      right: -4,
      bottom: -4,
      left: -4,
    },
    "&:hover": {
      background: fade(custom.low, 0.1),
    },
    "&:focus": {
      boxShadow: `0 0 4px ${primary.main}`,
    },
  },
  iconSvg: {
    fill: primary.main,
  },
  control: {
    display: "flex",
    alignItems: "center",
    width: 160,
    height: 32,
    borderRadius: 4,
    background: fade(custom.low, 0.06),
    border: "1px solid transparent",
    transition: "background 200ms, width 150ms",
    "&:focus-within": {
      border: `1px solid ${custom.border[200]}`,
      boxShadow: `0 0 4px ${primary.main}`,
    },
  },
  control_full: {
    width: "100%",
    "&:focus-within": {
      boxShadow: "none",
    },
  },
  control_large: {
    width: 240,
    "&$control_full": {
      width: "100%",
    },
  },
  controlSearch: {
    marginLeft: 8,
    fill: custom.grey[400],
  },
  controlInput: {
    width: "calc(100% - 56px)",
    margin: "0 8px",
    border: 0,
    outline: 0,
    color: custom.low,
    background: "transparent",
  },
  closeButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: 32,
    height: 32,
    marginLeft: 8,
    padding: 0,
    background: "none",
    border: 0,
    outline: 0,
    borderRadius: 4,
    cursor: "pointer",
    "&::before": {
      content: "''",
      position: "absolute",
      top: -4,
      right: -4,
      bottom: -4,
      left: -4,
    },
    "&:hover": {
      background: fade(custom.low, 0.1),
    },
    "&:focus": {
      boxShadow: `0 0 4px ${primary.main}`,
    },
  },
  closeSvg: {
    fill: primary.main,
  },
}));

export default useStyles;
